import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft, KeyRound, MailCheck } from "lucide-react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, formatApiErrorDetail } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email, origin_url: window.location.origin });
      setSent(true);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-slate-50 min-h-screen" data-testid="forgot-password-page">
      <Navbar />
      <main className="pt-32 pb-20 max-w-md mx-auto px-4 sm:px-6">
        <div className="bg-white border border-slate-200 rounded-3xl p-8 sm:p-10 shadow-xl shadow-slate-900/5 fade-up">
          <span className="inline-flex items-center justify-center h-12 w-12 rounded-2xl bg-cyan-50 text-cyan-600 mb-5">
            {sent ? <MailCheck className="h-6 w-6" /> : <KeyRound className="h-6 w-6" />}
          </span>
          {sent ? (
            <div data-testid="forgot-password-sent">
              <h1 className="text-2xl font-heading font-bold text-slate-900">Revisa tu correo</h1>
              <p className="text-sm text-slate-600 mt-3 leading-relaxed">
                Si existe una cuenta con <strong className="notranslate">{email}</strong>, te hemos enviado un enlace para crear una
                nueva contraseña. Caduca en 1 hora. Mira también la carpeta de spam.
              </p>
            </div>
          ) : (
            <>
              <h1 className="text-2xl font-heading font-bold text-slate-900">¿Olvidaste tu contraseña?</h1>
              <p className="text-sm text-slate-600 mt-2 mb-6">
                Escribe tu correo y te enviaremos un enlace para crear una nueva. Si te registraste con Google, también te servirá
                para añadir una contraseña a tu cuenta.
              </p>
              <form onSubmit={submit} className="space-y-4" data-testid="forgot-password-form">
                <div className="space-y-2">
                  <Label htmlFor="fp-email">Correo electrónico</Label>
                  <Input id="fp-email" data-testid="forgot-password-email-input" type="email" required autoComplete="email"
                    value={email} onChange={(e) => setEmail(e.target.value)} placeholder="tu@correo.com" />
                </div>
                <Button type="submit" disabled={loading} data-testid="forgot-password-submit-btn"
                  className="w-full h-11 rounded-full bg-cyan-500 hover:bg-cyan-600">
                  {loading ? "Enviando..." : "Enviar enlace"}
                </Button>
              </form>
            </>
          )}
          <Link to="/cuenta" data-testid="forgot-password-back-link"
            className="mt-6 inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-cyan-700">
            <ArrowLeft className="h-4 w-4" /> Volver a iniciar sesión
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}
